import { PATH } from "./path";

export const HEADER_LINKS = [
  {
    label: "Home",
    href: PATH.HOME,
  },
  {
    label: "Service",
    href: PATH.SERVICE,
  },
  {
    label: "Pricing",
    href: PATH.PRICING,
  },
  {
    label: "Blog",
    href: PATH.BLOG,
  },
];
